"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeDefaultOwnerPropertyValue = exports.changeDefaultContactPropertyValue = exports.changeDefaultCompanyPropertyValue = exports.EmailDefaultPropertiesActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _interactions = require("../../../../../website/modules/pages/constants/interactions");

var _mapPayloadTo = _interopRequireDefault(require("redux-less/utils/mapPayloadTo"));

var EmailDefaultPropertiesActionTypes = (0, _namespacedKeyMirror.default)({
  CHANGE_DEFAULT_EMAIL_COMPANY_PROPERTY_VALUE: null,
  CHANGE_DEFAULT_EMAIL_CONTACT_PROPERTY_VALUE: null,
  CHANGE_DEFAULT_EMAIL_OWNER_PROPERTY_VALUE: null
}, 'email');
exports.EmailDefaultPropertiesActionTypes = EmailDefaultPropertiesActionTypes;
var changeDefaultCompanyPropertyValue = (0, _fluxActions.createAction)(EmailDefaultPropertiesActionTypes.CHANGE_DEFAULT_EMAIL_COMPANY_PROPERTY_VALUE, (0, _mapPayloadTo.default)(_interactions.SELECTED_PROPERTY, 'allDomainsOrDomainName', 'value'));
exports.changeDefaultCompanyPropertyValue = changeDefaultCompanyPropertyValue;
var changeDefaultContactPropertyValue = (0, _fluxActions.createAction)(EmailDefaultPropertiesActionTypes.CHANGE_DEFAULT_EMAIL_CONTACT_PROPERTY_VALUE, (0, _mapPayloadTo.default)(_interactions.SELECTED_PROPERTY, 'allDomainsOrDomainName', 'value'));
exports.changeDefaultContactPropertyValue = changeDefaultContactPropertyValue;
var changeDefaultOwnerPropertyValue = (0, _fluxActions.createAction)(EmailDefaultPropertiesActionTypes.CHANGE_DEFAULT_EMAIL_OWNER_PROPERTY_VALUE, (0, _mapPayloadTo.default)(_interactions.SELECTED_PROPERTY, 'allDomainsOrDomainName', 'value'));
exports.changeDefaultOwnerPropertyValue = changeDefaultOwnerPropertyValue;